import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { setupGlobalErrorHandlers } from './services/errorReporting'

// Setup global error handlers for uncaught errors and unhandled promise rejections
setupGlobalErrorHandlers()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
